import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { DocumentConstants } from 'app/constants/document.constants';
import { FormService } from 'app/services/form.service';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-cover-letter',
  templateUrl: './cover-letter.component.html',
  styleUrls: ['./cover-letter.component.scss']
})
export class CoverLetterComponent {
  readonly dialog = inject(MatDialog);

  constructor(protected formService: FormService) {}

  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
          data: { fileName: DocumentConstants.COVER_LETTER }
        });
    dialogRef.afterClosed().subscribe();
  }
  
  get hasCoverLetterFile(): boolean {
    return this.formService.doesCurrentFormHaveAttachmentForSection(DocumentConstants.COVER_LETTER);
  }

  get attachments(): AttachmentModel[] {
    return this.formService.allAttachmentsForSection(DocumentConstants.COVER_LETTER);
  }

  get formType(): string {
    return this.formService.getCurrentUsanFormType();
  }

  get isFormDType(): boolean {
    return 'FormD' === this.formType;
  }
}
